<ng-container *ngIf="!phxLoading">
  <phx-tile
    class="phx-navigation-button-item phx-navigation-button-direction"
    [class.phx-navigation-button-prev-disabled]="phxLeftNavigationDisabled"
    [phxClickable]="true"
    [phxBorder]="true"
    [phxBorderStates]="true"
    [phxBackgroundStates]="true"
    [phxBackground]="phxBackground"
    [phxDisabled]="phxLeftNavigationDisabled"
    (phxClick)="phxOnLeftNavigation.emit($event)"
    (keydown.enter)="phxOnLeftNavigation.emit($event)"
  >
    <span phxText [class.phx-navigation-button-item-content-xs]="phxSize === PHX_SIZE.XS"><i phx-icon [size]="phxSize === PHX_SIZE.XS ? PHX_ICON_SIZE_XS : PHX_ICON_SIZE_DEFAULT" [phxIcon]="phxPrefixIcon" color="currentColor"></i></span>
  </phx-tile>
  <phx-tile
    *ngIf="!phxHideNavigationContent"
    class="phx-navigation-button-item"
    [class.phx-navigation-button-prev-disabled]="phxLeftNavigationDisabled"
    [class.phx-navigation-button-next-disabled]="phxRightNavigationDisabled"
    [phxBorder]="true"
    [phxBackground]="phxBackground"
  >
    <span phxText [class.phx-navigation-button-item-content-xs]="phxSize === PHX_SIZE.XS"
    ><ng-content></ng-content></span>
  </phx-tile>
  <phx-tile
    class="phx-navigation-button-item phx-navigation-button-direction"
    [class.phx-navigation-button-next-disabled]="phxRightNavigationDisabled"
    [phxClickable]="true"
    [phxBorder]="true"
    [phxBorderStates]="true"
    [phxBackgroundStates]="true"
    [phxBackground]="phxBackground"
    [phxDisabled]="phxRightNavigationDisabled"
    (phxClick)="phxOnRightNavigation.emit($event)"
    (keydown.enter)="phxOnRightNavigation.emit($event)"
  >
    <span phxText [class.phx-navigation-button-item-content-xs]="phxSize === PHX_SIZE.XS"><i phx-icon [size]="phxSize === PHX_SIZE.XS ? PHX_ICON_SIZE_XS : PHX_ICON_SIZE_DEFAULT" [phxIcon]="phxSuffixIcon" color="currentColor"></i></span>
  </phx-tile>
</ng-container>
<div *ngIf="phxLoading">
  <phx-skeleton phxWidth="120px" phxHeight="36px" phxShape="rounded"></phx-skeleton>
</div>
